import { useMemo } from 'react';
import { FiservCardHolder } from '@common-fe/common-fe';

import { useAuthStore } from '@/modules/user/stores';

import { DependentFormValue } from '../AddCardDependentForm';
import { DependentInfoDto } from '../queries/useAddDependentCard.query';

export const useSetDependent = (dependentInfo: DependentFormValue | FiservCardHolder | null) => {
  const { user } = useAuthStore();

  const preparedDependent = useMemo(() => ({
    id: dependentInfo?.dependentId,
    firstName: dependentInfo?.firstName,
    lastName: dependentInfo?.lastName,
    ssn: (dependentInfo as DependentFormValue | null)?.ssn,
    birthOn: dependentInfo?.dateOfBirth,
    person: {
      id: user?.id,
      preferredName: user?.preferredName,
      firstName: user?.firstName,
      lastName: user?.lastName,
    },
    employee_id: user?.employee?.id,
    relationshipType: dependentInfo?.relationship?.toUpperCase() || 'OTHER',
  } as DependentInfoDto), [user, dependentInfo]);

  return preparedDependent;
};
